import axios from 'axios';
import router from "@/router";

let state = {
    summary: {},
    configNumberZLM: null,
    configurationOverviewsManualId: null,
    LNG: null,
    Quantity_Motor: null,
    showInverterDetails: false,
    showEVACDetails: false,
    showZArecDetails: false,

    showTemplateButton: false,
    zlwNumber: null,
    showModalZlw: false,
    /*LNG: '10. German'*/

    showMotorCablesDetails: false,
    showMotorSuppliesDetails: false,
    showMotorPackagingDetails: false,
    showFrameDetails: false,

    atkonfSelection: [],
    suffixSelection: [],

    zlwInverterSeries: null,
    zlwInverterType: null,
    zlwBrakeResistorType: null,
    zlwRecuperationType: null,
    zlwRadioInterferenceFilterType: null,
    zlwBrakeControlType: null,

    loaderExistingConfigurations: false,
    kid: null,
    customerNameOverviewSelection: [],
    technicalConfiguration: false,
}

const actions = {
    change_motorInformations_toDefault_storeAction() {
        this.dispatch('inputsManual/set_inputManual_toDefault_storeAction');
        this.dispatch('driveTechnologiesManual/change_driveTechnologies_toDefault_storeAction');
        this.dispatch('cables/change_cablesManual_toDefault_storeAction');
        this.dispatch('suppliesMotorManual/change_suppliesMotorManual_toDefault_storeAction');
        this.dispatch('packagingMotorManual/change_packagingMotor_toDefault_storeAction')
        this.dispatch('frameManual/changed_frameManual_toDefault');
        this.commit('inputsManual/change_motorManualData_storeMutation', null);
        this.commit('psgModal/change_motorSchModData_storeMutation', null);
    },
    check_configurationOverviewsManualId_storeAction({ commit, dispatch }) {
        if (sessionStorage.getItem('IDM')) {
            commit('change_configurationOverviewsManualId_storeMutation', sessionStorage.getItem('IDM'));
            dispatch('check_configurationManual_Exist_storeAction', state.configurationOverviewsManualId)
        }
        else {
            commit('change_showTemplateButton_storeMutation', false);
            commit('change_configurationOverviewsManualId_storeMutation', null);
        }
    },
    async change_configurationOverviewsManualId_storeAction({ commit, dispatch }, value) {
        await commit('change_configurationOverviewsManualId_storeMutation', value);
        if (state.configurationOverviewsManualId != null) {
            sessionStorage.setItem('IDM', state.configurationOverviewsManualId);
            await dispatch('check_configurationManual_Modifiable_storeAction');
        }
        else {
            if (sessionStorage.getItem('IDM')) {
                sessionStorage.removeItem('IDM')
            }
            await commit('change_showTemplateButton_storeMutation', false);
        }
    },
    async insertOrUpdate_CustomerName_storeAction({ dispatch }, value) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            configurationOverviewsManualId: state.configurationOverviewsManualId,
            kid: value,
        }
        await axios({
            method: 'post',
            url: '/api/configurations/insertOrUpdate_CustomerName_storeAction/',
            data: {
                data: data,
            }
        })
            .then((response) => {
                if (response.data.status.statusCode.substring(0, 1) == '2') {
                    if (response.data.data.changedDataset == true) {
                        dispatch('change_configurationOverviewsManualId_storeAction', response.data.data.configurationOverviewsManualId);
                        dispatch('get_configurationManualInformations_storeAction');

                    }
                }
            })
            .catch(() => {
            })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    async check_configuration_storeAction({ dispatch }, value) {
        if (value != null && value.toLowerCase().substring(0, 4) == 'zlm-') {
            dispatch('check_ZLM_Exist_storeAction', value);
        }
        else {
            dispatch('check_configNumber_storeAction', value);
        }
    },
    async check_ZLM_Exist_storeAction({ commit, dispatch, rootState }, value) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        await axios({
            method: 'post',
            url: '/api/inputsManual/check_ZLM_Exist/' + value,
        })
            .then((response) => {
                if (response.data.configurationOverviewsManualId != null) {
                    dispatch('change_configurationOverviewsManualId_storeAction', response.data.configurationOverviewsManualId);
                    commit('change_configNumberZLM_storeMuatation', response.data.zlm);
                    dispatch('get_configurationManualInformations_storeAction');
                    //this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
                    //dispatch('get_checkConfigurationZLM_storeAction', response.data.configurationOverviewsManualId);
                }
                else {
                    dispatch('change_configurationOverviewsManualId_storeAction', null);
                    commit('change_configNumberZLM_storeMuatation', null);
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }
            })
            .catch(() => {
            })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },
    async check_configurationManual_Exist_storeAction({ dispatch, commit }, value) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            configurationOverviewsManualId: value,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/check_configurationManual_Exist',
            data: {
                data: data,
            }
        })
            .then((response) => {
                dispatch('change_configurationManual_Exist_storeAction', response.data);
            })
            .catch(() => {
            })
            .then(() => {
                //this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

   async change_configurationManual_Exist_storeAction({ dispatch, commit }, value) {
        if (value.configurationOverviewsManualId != null) {
            await dispatch('change_configurationOverviewsManualId_storeAction', value.configurationOverviewsManualId);
            await commit('change_configNumberZLM_storeMuatation', value.zlm);
            await dispatch('get_configurationManualInformations_storeAction');
        }
        else {
            await dispatch('change_configurationOverviewsManualId_storeAction', null);
            await commit('change_configNumberZLM_storeMuatation', null);
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },

    async get_configurationManualInformations_storeAction({ dispatch, rootState }) {
        await this.dispatch('inputsManual/set_inputManual_toDefault_storeAction');
        await this.dispatch('driveTechnologiesManual/change_driveTechnologies_toDefault_storeAction');
        await this.dispatch('cables/change_cablesManual_toDefault_storeAction');
        await this.dispatch('suppliesMotorManual/change_suppliesMotorManual_toDefault_storeAction');
        await this.dispatch('packagingMotorManual/change_packagingMotor_toDefault_storeAction')
        await this.dispatch('frameManual/changed_frameManual_toDefault');
        await this.dispatch('inputsManual/loadAllDataMotorManual_storeAction');
        await this.dispatch('FI/loadAllDataInverterManual_storeAction');
        await this.dispatch('EVAC/loadAllDataEVACManual_storeAction');
        await this.dispatch('ZArec/loadAllDataZArecManual_storeAction');
    },

    async check_configurationManual_Modifiable_storeAction({ dispatch }) {
        if (state.configurationOverviewsManualId != null) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
            const data = {
                configurationOverviewsManualId: state.configurationOverviewsManualId,
            }
            await axios({
                method: 'post',
                url: '/api/inputsManual/check_configurationManual_Modifiable',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    dispatch('change_showTemplateButton_storeAction', response.data)
                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                })
        }
    },

    async check_existingConfigurations_storeAction({ commit, dispatch }, value) {
        commit('change_loaderExistingConfigurations_storeMutation', true);
        const data = {
            configurationNumber: value.calculationNumber,
            atkonfNumber: value.atkonfNumber,
            itemNumber: value.itemNumber,
            documentNumber: value.documentNumber,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/check_existingConfigurations/',
            data: {
                data: data,
            }

        })
            .then((response) => {
                dispatch('change_atkonfSelection_storeAction', response.data.data.atkonfSelection);
            })
            .catch(() => {
            })
            .then(() => {
                commit('change_loaderExistingConfigurations_storeMutation', false);
            })
    },
    change_atkonfSelection_storeAction({ commit }, value) {
        commit('change_atkonfSelection_storeMutation', value);
    },

    get_configurationOverviewsId_storeAction() {
        const configurationOverviewsId = sessionStorage.getItem('id');
        commit('change_configurationOverviewsId_storeMutation', configurationOverviewsId)
    },
    change_ZlwNumber_storeAction({ commit }, value) {
        commit('change_ZlwNumber_storeMutation', value);
    },

    //async check_zlwNumber_storeAction({ dispatch }, value) {
    //    const zlw = value;
    //    await axios({
    //        method: 'post',
    //        url: '/api/inputsManual/check_zlwNumber/' + zlw,
    //    })
    //        .then((response) => {
    //            dispatch('change_zlwNumber_storeAction', response.data);
    //        })
    //        .catch(() => {
    //        })
    //        .then(() => {
    //            //this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
    //        })
    //},
    async change_zlwNumber_storeAction({ dispatch }, value) {
        await dispatch('change_configurationOverviewsManualId_storeAction', null);
        await this.dispatch('configurations/set_configurationOverviewsId_at_sessionStorage_storeAction',value.data.configurationOverviewsId);
        await dispatch('change_ZlwNumber_storeAction',value.data.zAlift_ID);
        await dispatch('change_showModalZlw_storeAction', false);

        await dispatch('get_ZlwDataFromSql_storeAction');
    },
    async check_configNumber_storeAction({ dispatch }, value) {
        const zlw = value;
        await axios({
            method: 'post',
            url: '/api/inputsManual/check_configNumber/' + zlw,
        })
            .then((response) => {
                if (response.data.configurationModifiable != null && response.data.configurationModifiable == false) {
                    dispatch('get_checkConfigurationZLM_storeAction', response.data.configurationOverviewsManualId);
                }
                else {
                    dispatch('change_configNumber_storeAction', response.data.configurationOverviewsManualId);
                }
            })
            .catch(() => {
            })
            .then(() => {
                //this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },
    async change_configNumber_storeAction({ dispatch }, value) {
        if (value != null && value != '') {
           await dispatch('change_configurationOverviewsManualId_storeAction', value);
           await dispatch('get_configurationManualInformations_storeAction');
        }
        else {
           await dispatch('change_configurationOverviewsManualId_storeAction', null);
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },
    change_showModalZlw_storeAction({ commit }, value) {
        this.dispatch('configurations/MANU', true);
        commit('change_showModalZlw_storeMutation', value);
    },
    async check_configurationManualTemplate_storeAction({ dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            configurationOverviewsManualId: state.configurationOverviewsManualId,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/check_configurationManualTemplate',
            data: {
                data: data,
            }
        })
            .then((response) => {
                if (response.data != null) {
                    dispatch('change_configurationOverviewsManualId_storeAction', response.data.configurationOverviewsManualId);
                    dispatch('get_configurationManualInformations_storeAction');
                }
                else {
                    dispatch('change_configurationOverviewsManualId_storeAction', null);
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }
            })
            .catch(() => {
            })
            .then(() => {
                //this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },
    change_showTemplateButton_storeAction({ commit }, modifiable) {
        if (modifiable == false) {
            commit('change_showTemplateButton_storeMutation', true);
        }
        else {
            commit('change_showTemplateButton_storeMutation', false);
        }
    },

    async get_ZlwDataFromSql_storeAction({ dispatch, rootState }) {
        await this.dispatch('inputsManual/set_inputManual_toDefault_storeAction');
        await this.dispatch('driveTechnologiesManual/change_driveTechnologies_toDefault_storeAction');
        await this.dispatch('cables/change_cablesManual_toDefault_storeAction');
        await this.dispatch('suppliesMotorManual/change_suppliesMotorManual_toDefault_storeAction');
        await this.dispatch('packagingMotorManual/change_packagingMotor_toDefault_storeAction');
        await this.dispatch('frameManual/changed_frameManual_toDefault');

        await this.dispatch('inputsManual/loadAllDataMotorManualZlw_storeAction');

    },

    async get_webConfiguration_storeAction({ dispatch, commit }, value) {
        //await dispatch('check_zlwNumber_storeAction', value);
        //.push('../manualStep/addOnPartModal');
        await dispatch('change_configurationOverviewsManualId_storeAction', null);
        await dispatch('change_ZlwNumber_storeAction', value);
        await dispatch('change_showModalZlw_storeAction', false);
        await dispatch('check_configNumberKid_storeAction', value);
        //router.push('../manualStep/manualHome');
    },

    async check_configNumberKid_storeAction({ commit, dispatch, rootState }, value) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            zlw: value,
            kid: rootState.manualHome.kid,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/check_configNumberKid',
            data: {
                data: data,
            }
        })
            .then((response) => {
                if (response.data.configurationModifiable != null && response.data.configurationModifiable == false) {
                    dispatch('get_checkConfigurationZLM_storeAction', response.data.configurationOverviewsManualId);
                    commit('change_technicalConfiguration_storeMutation', true);
                }
                else {
                    dispatch('get_ZlwDataFromSql_storeAction');
                    commit('change_technicalConfiguration_storeMutation', true);
                }
            })
            .catch(() => {
            })
            .then(() => {
            })
    },


    async get_atkonfInformation_storeAction({ commit, dispatch }, value) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        dispatch('change_showModalZlw_storeAction', false);

        const data = {
            atkonfNumber: (value != null && value.hasOwnProperty('atkonfNumber')) ? value.atkonfNumber : null,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_atkonfInformation',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                if (response.data != null && response.data.data != null) {
                    if (response.data.data.configurationOverviewsManualId != null) {
                        dispatch('change_configurationOverviewsManualId_storeAction', response.data.data.configurationOverviewsManualId);
                        this.commit('inputsManual/change_atkonfConfigurationDifferencePartNumbers_storeMutation', response.data.data.partNumbers);
                        dispatch('get_configurationManualInformations_storeAction');
                    }
                    else {
                        dispatch('change_motorInformations_toDefault_storeAction');
                        dispatch('change_configurationOverviewsManualId_storeAction', null);
                        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                    }
                }
                else {
                    dispatch('change_motorInformations_toDefault_storeAction');
                    dispatch('change_configurationOverviewsManualId_storeAction', null);
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }

            })
            .catch(() => {
            })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    async get_checkConfigurationZLM_storeAction({ commit, dispatch, rootState }, value) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        //dispatch('change_showModalZlw_storeAction', false);

       await axios({
            method: 'post',
            url: '/api/inputsManual/get_checkConfigurationZLM/' + value,
        })
           .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                if (response.data != null && response.data.data != null) {
                    if (response.data.data.configurationOverviewsManualId != null) {
                        dispatch('change_configurationOverviewsManualId_storeAction', response.data.data.configurationOverviewsManualId);
                        this.commit('inputsManual/change_atkonfConfigurationDifferencePartNumbers_storeMutation', response.data.data.partNumbers);
                        dispatch('get_configurationManualInformations_storeAction');
                    }
                    else {
                        dispatch('change_motorInformations_toDefault_storeAction');
                        dispatch('change_configurationOverviewsManualId_storeAction', null);
                        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                    }
                }
                else {
                    dispatch('change_motorInformations_toDefault_storeAction');
                    dispatch('change_configurationOverviewsManualId_storeAction', null);
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }

            })
           .catch(() => {
               this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
           .then(() => {
               if (state.technicalConfiguration == true) {
                   router.push('../manualStep/ManualHome');
               }
                //this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    change_suffix_storeAction({ rootState, commit, dispatch }, value) {
        if (value != null && value.hasOwnProperty('number') && value.number != null) {
            this.commit('FI/change_FI_toDefault_selection_storeMutation');
            this.commit('EVAC/change_EVAC_toDefault_selection_storeMutation');
            this.commit('ZArec/change_ZArec_toDefault_selection_storeMutation');
            dispatch('change_configurationOverviewsManualId_storeAction', value.number);
            dispatch('get_configurationManualInformations_storeAction');
        }
    },
    async change_calculationModifiable_storeAction({ rootState, commit, dispatch }) {
        if (state.configurationOverviewsManualId != null) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
            const data = {
                configurationOverviewsManualId: state.configurationOverviewsManualId,
            }
            await axios({
                method: 'post',
                url: '/api/inputsManual/change_calculationModifiable',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                    dispatch('check_configurationManual_Modifiable_storeAction');
                    dispatch('get_zlmNumber_storeAction');
                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                })
        }
    },
    async get_zlmNumber_storeAction({ rootState, commit, dispatch }) {
        if (state.configurationOverviewsManualId != null) {
            const data = {
                configurationOverviewsManualId: state.configurationOverviewsManualId,
            }
            await axios({
                method: 'post',
                url: '/api/inputsManual/get_zlmNumber',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    if (response.data != null && response.data != '') {
                        commit('change_configNumberZLM_storeMuatation', response.data);
                    }
                })
                .catch(() => {
                })
                .then(() => {
                })
        }
    },


    async delete_calculationZAtop_storeAction({ dispatch }) {
        if (state.configurationOverviewsManualId != null) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
            const data = {
                configurationOverviewsManualId: state.configurationOverviewsManualId,
            }
            await axios({
                method: 'post',
                url: '/api/configurations/delete_calculationZAtop',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                    dispatch('get_configurationManualInformations_storeAction');
                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                })
        }
    },
    async delete_calculationFrame_storeAction({ dispatch }) {
        if (state.configurationOverviewsManualId != null) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
            const data = {
                configurationOverviewsManualId: state.configurationOverviewsManualId,
            }
            await axios({
                method: 'post',
                url: '/api/configurations/delete_calculationFrame',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                    dispatch('get_configurationManualInformations_storeAction');
                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                })
        }
    },

    async delete_calculationZAdyn_storeAction({ dispatch, commit }) {
        if (state.configurationOverviewsManualId != null) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
            const data = {
                configurationOverviewsManualId: state.configurationOverviewsManualId,
            }
            await axios({
                method: 'post',
                url: '/api/configurations/delete_calculationZAdyn',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                    dispatch('get_configurationManualInformations_storeAction');

                    this.commit('FI/change_FI_toDefault_selection_storeMutation')

                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });

                })


        }
    },
    async delete_calculationEVAC_storeAction({ dispatch, commit }) {
        if (state.configurationOverviewsManualId != null) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
            const data = {
                configurationOverviewsManualId: state.configurationOverviewsManualId,
            }
            await axios({
                method: 'post',
                url: '/api/configurations/delete_calculationEVAC',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                    dispatch('get_configurationManualInformations_storeAction');
                    this.commit('EVAC/change_EVAC_toDefault_selection_storeMutation')
                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                })
        }
    },
    async delete_calculationZArec_storeAction({ dispatch, commit }) {
        if (state.configurationOverviewsManualId != null) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
            const data = {
                configurationOverviewsManualId: state.configurationOverviewsManualId,
            }
            await axios({
                method: 'post',
                url: '/api/configurations/delete_calculationZArec',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                    dispatch('get_configurationManualInformations_storeAction');
                    this.commit('ZArec/change_ZArec_toDefault_selection_storeMutation')
                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                })
        }
    },
    async check_toDos_at_manualHome_storeAction({ dispatch, commit }) {
        await commit('change_customerNameOverviewSelection_storeMutation', []);
        await dispatch('change_motorInformations_toDefault_storeAction');
        await this.commit('configurations/change_elevatorMotor_Manual_storeMutation', false);
        await this.commit('configurations/MANU_configuration', true);
        await this.dispatch('configurations/remove_configurationOverviewsId_at_sessionStorage_storeAction');

        //await this.commit('configurations/change_sap_storeMutation', true);

        await dispatch('check_configurationOverviewsManualId_storeAction');
        await dispatch('check_configurationManual_Exist_storeAction', state.configurationOverviewsManualId);
    },

    async get_customerNameSelectionOverview_storeAction({ rootState, commit, dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_customerNameOverviewSelection',
        })
            .then((response) => {
                commit('change_customerNameOverviewSelection_storeMutation', response.data);
                const kid = state.kid != null ? state.kid : 'ZA';
                const firstIndex_whichMeetConditions = response.data.findIndex(i => i.text.text == kid);
                if (firstIndex_whichMeetConditions > -1) {
                    commit('change_customerNameOverviewSelected_storeMutation', response.data[firstIndex_whichMeetConditions].text.text);
                }
            })
            .catch(() => {
            })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },
    change_customerNameOverview_storeAction({ commit, dispatch }, value) {
        const kid = state.kid;
        commit('change_customerNameOverviewSelected_storeMutation', value.text.text);
        if (kid != value.text.text && state.configurationOverviewsManualId != null) {
            dispatch('insertOrUpdate_CustomerName_storeAction', state.kid);
        }
    },
}


const mutations = {
    change_configNumberZLM_storeMuatation(state, payload) {
        state.configNumberZLM = payload
    },
    change_configurationOverviewsManualId_storeMutation(state, payload) {
        state.configurationOverviewsManualId = payload;
    },
    change_LNG_storeMutation(state, payload) {
        state.LNG = payload;
    },
    change_Quantity_Motor_storeMutation(state, payload) {
        state.Quantity_Motor = payload;
    },
    change_showInverterDetails_storeMutation(state, payload) {
        state.showInverterDetails = payload;
    },
    change_showEVACDetails_storeMutation(state, payload) {
        state.showEVACDetails = payload;
    },
    change_showZArecDetails_storeMutation(state, payload) {
        state.showZArecDetails = payload;
    },
    change_showTemplateButton_storeMutation(state, payload) {
        state.showTemplateButton = payload;
    },
    change_ZlwNumber_storeMutation(state, payload) {
        state.zlwNumber = payload;
    },
    change_ZlwInverterSeries_storeMutation(state, payload) {
        state.zlwInverterSeries = payload;
    },
    change_ZlwInverterType_storeMutation(state, payload) {
        state.zlwInverterType = payload;
    },
    change_ZlwBrakeResistorType_storeMutation(state, payload) {
        state.zlwBrakeResistorType = payload;
    },
    change_ZlwRecuperationType_storeMutation(state, payload) {
        state.zlwRecuperationType = payload;
    },
    change_ZlwRadioInterferenceFilterType_storeMutation(state, payload) {
        state.zlwRadioInterferenceFilterType = payload;
    },
    change_ZlwBrakeControlType_storeMutation(state, payload) {
        state.zlwBrakeControlType = payload;
    },
    change_showModalZlw_storeMutation(state, payload) {
        state.showModalZlw = payload;
    },
    change_showMotorCablesDetails_storeMutation(state, payload) {
        state.showMotorCablesDetails = payload;
    },
    change_showMotorSuppliesDetails_storeMutation(state, payload) {
        state.showMotorSuppliesDetails = payload;
    },
    change_showMotorPackagingDetails_storeMutation(state, payload) {
        state.showMotorPackagingDetails = payload;
    },
    change_showMotorFrameDetails_storeMutation(state, payload) {
        state.showFrameDetails = payload;
    },

    change_atkonfSelection_storeMutation(state, payload) {
        state.atkonfSelection = payload;
    },
    change_suffixSelection_storeMutation(state, payload) {
        state.suffixSelection = payload;
    },
    change_loaderExistingConfigurations_storeMutation(state, payload) {
        state.loaderExistingConfigurations = payload;
    },
    change_customerNameOverviewSelection_storeMutation(state, payload) {
        state.customerNameOverviewSelection = payload;
    },
    change_kid_storeMutation(state, payload) {
        state.kid = payload;
        if (state.kid == null) {
            state.kid = "ZA";
        }
    },
    change_customerNameOverviewSelected_storeMutation(state, payload) {
        state.kid = 'ZA'
        for (let i = 0; i < state.customerNameOverviewSelection.length; i++) {
            state.customerNameOverviewSelection[i].selected = false;

            if (state.customerNameOverviewSelection[i].text.text == payload) {
                state.customerNameOverviewSelection[i].selected = true;
                state.kid = payload;
            }
        }
    },
    change_technicalConfiguration_storeMutation(state, payload) {
        state.technicalConfiguration = payload;
    },

}
export const manualHome = {
    namespaced: true,
    components: {
        axios,
    },
    state,
    actions,
    mutations
}